import React from 'react'
import {
  Box, ResponsiveBox, ResponsiveText, IcoMoon,
  BuildIcon,
} from '@usap/uicomponents'
import useStyle from './useStyle'
import useWmoEnabled from '../../../../../../../hooks/useWmoEnabled'
import { usePowersports } from '../../../../../../../hooks/usePowersports'
import UniversalFitWmo from './UniversalFitWmo'

const UniversalFit = props => {
  const { data } = props
  const { modifiers } = data
  const isWmoEnabled = useWmoEnabled()
  const isPowersportsEnabled = usePowersports()

  let vehicle = ''

  if (modifiers && modifiers.vehicle && modifiers.vehicle.details) {
    const {
      year, make, model, submodel, engine,
    } = modifiers.vehicle.details
    vehicle = [
      `${year}`,
      `${make}`,
      `${model}`,
      `${submodel || ''}`,
      `${engine || ''}`,
    ].join(' ')
  }

  const style = useStyle()
  const isPowersport = isPowersportsEnabled && ((typeof modifiers?.vehicle?.details?.vehicleType !== 'undefined' &&
                        modifiers?.vehicle?.details?.vehicleType?.toLowerCase() !== 'car/truck/suv') ||
                        typeof modifiers?.vehicle?.details?.vehicleType === 'undefined')

  if (isWmoEnabled) {
    return <UniversalFitWmo vehicle={vehicle} isPowersport={isPowersport} />
  }
  return (
    <ResponsiveBox
      border={style.wrapperBorder}
      round="4px"
      pad={style.wrapperPad}
      fxMargin={style.wrapperFxMargin}
    >
      <Box direction="row" style={style.containerPosition}>
        <Box align="center" justify="center" style={style.iconWrapperMinWidth}>
          <Box
            justify="center"
            align="center"
            margin="xsmall"
            width="34px"
            height="34px"
            round="50%"
            background="#666666"
            border={style.iconWrapperBorderColor}
          >
            <IcoMoon
              icon={BuildIcon}
              color="white"
              size="24px"
            />
          </Box>
        </Box>
        <Box pad={style.textWrapperPad} align="start" justify="center" width="100%">
          <ResponsiveText
            weight="bold"
            color="dark-2"
            fxSize={style.textFxSize}
          >
            Universal Fit
          </ResponsiveText>

          {(vehicle !== '') && (
            <ResponsiveText
              weight="bold"
              color="dark-2"
              fxSize={style.linkFxSize}
            >
              {vehicle}
            </ResponsiveText>
          )}
        </Box>
      </Box>
    </ResponsiveBox>
  )
}

export default UniversalFit
